import { SVGProps } from 'react';

function Delete(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={20}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.25 3.75h17.5"
        stroke="#7B829D"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M11.875 1.25h-3.75c-.69 0-1.25.56-1.25 1.25v1.25h6.25V2.5c0-.69-.56-1.25-1.25-1.25Z"
        stroke="#7B829D"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.125 14.375v-6.25M11.875 14.375v-6.25"
        stroke="#7B829D"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M15.72 17.603a1.25 1.25 0 0 1-1.245 1.147h-8.95a1.25 1.25 0 0 1-1.245-1.147L3.125 3.75h13.75l-1.154 13.853Z"
        stroke="#7B829D"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Delete.defaultProps = {
  role: 'graphics-document',
};

export default Delete;
